import { useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var usePlanData = function () {
    var _a;
    var plan = useState(findParamInLocalStorage("Plan"))[0];
    var productCode = useState((_a = findParamInLocalStorage("productCode", "steps")) !== null && _a !== void 0 ? _a : "")[0];
    var planCode = useState(function () { var _a, _b; return (_b = (_a = plan === null || plan === void 0 ? void 0 : plan[0]) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : ""; })[0];
    return {
        productCode: productCode,
        planCode: planCode,
    };
};
